var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popover',{ref:"popover",attrs:{"title":_vm.title},on:{"show":_vm.onPopoverShow,"hide":_vm.onPopoverHide}},[_c('span',[_vm._v("设置起量状态 ")]),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.confirm}},[_vm._v("关闭一键起量")]),_c('el-button',{attrs:{"slot":"ref","type":"text"},slot:"ref"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }